/**
 * Normalizes raw Sims event records into stable ids and reusable evidence fields.
 */
export function normalizeEventRecords(events = []) {
  return events.map((event, index) => {
    if (!event._eventId) {
      event._eventId = `event_${String(index + 1).padStart(3, '0')}`
    }
    return event
  })
}

export function getEventCharacters(event) {
  const names = []
  if (event.interactor) names.push(event.interactor)
  const interactees = Array.isArray(event.interactee)
    ? event.interactee
    : [event.interactee]
  interactees.filter(Boolean).forEach(name => names.push(name))
  return Array.from(new Set(names))
}

export function normalizeEvidenceIds(rawIds, events, warnings = []) {
  const allowedIds = new Set(events.map(event => event._eventId))
  const selectedIds = events.map(event => event._eventId)
  if (!Array.isArray(rawIds)) {
    warnings.push('Evidence ids were missing, so selected event ids were used.')
    return selectedIds
  }
  const uniqueValidIds = Array.from(
    new Set(
      rawIds.map(id => String(id || '').trim()).filter(id => allowedIds.has(id))
    )
  )
  if (uniqueValidIds.length !== rawIds.length) {
    warnings.push('Some evidence ids were invalid and were removed.')
  }
  if (!uniqueValidIds.length) {
    warnings.push(
      'No valid evidence ids remained, so selected event ids were used.'
    )
    return selectedIds
  }
  return uniqueValidIds
}
